import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoursesService } from 'src/app/services/courses.service';

@Component({
  selector: 'app-courses-overview',
  templateUrl: './courses-overview.component.html',
  styleUrls: ['./courses-overview.component.css']
})
export class CoursesOverviewComponent implements OnInit {

  // List of courses
  courses: any[] = [];

  // Array for progress and colors
  progressList: any[] = [];
  colors: any = []
  rentWiseAgency: any = {};

  constructor(private coursesService: CoursesService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.rentWiseAgency = this.coursesService.rentWiseAgency;
    this.courses = this.coursesService.courses;

    // For each course calculate progress based on which course it is
    this.courses.forEach((course) => {
      let progress = course.courseID !== 'RentWise' ? course.fheProgress : course.rentwiseProgress;

      this.progressList.push(progress);

      // Low progress
      if (progress <= 20) {
        this.colors.push( {
          outerColor: '#FC051A',
          innerColor: '#f57687'
        })
      }

      // Medium progress
      if (progress > 20 && progress < 60) {
        this.colors.push( {
          outerColor: '#FFEA00',
          innerColor: '#FFFF8F'
        })
      }

      // High progress
      if (progress >= 60) {
        this.colors.push( {
          outerColor: '#008000',
          innerColor: '#50C878'
        })
      }
    });
  }

  // Navigate to the course clicked on
  onCourse(course: any) {
    const title = course.courseID;

    // Set current course
    this.coursesService.currentCourse = course;

    this.router.navigate(['/courses', title]);
  }
}
